import React, {useState,useMemo} from 'react';
import { Link,Redirect } from "react-router-dom";
import useStyles from './Styles';
import CopyToClipboard from 'react-copy-to-clipboard';
import Tooltip from '@mui/material/Tooltip';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddIcon from '@mui/icons-material/Add';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import {Inc,Owner,ConsignSheetSearchCondition,ConsignSheet} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import Loading from './Loading';
import ConsignListSearch from './ConsignListSearch';
import ConsignInput from './ConsignInput';
import StoreImg from './StoreImg';
import Title from './Title';
import Yesno from './Yesno';
import Toast from './Toast';
import MultiLines from './MultiLines';
import AppBank from './AppBank';

interface ConsignListProps {
	owner:Owner,
	bank:AppBank,
}
let page:number = 1;

const ConsignList = (pr:ConsignListProps)=> {
    Ajax.setEditorId( pr.owner.owner_id );
    const classes = useStyles();
	const [toast,setToast] = useState('');
    const [states,setStates] = useState({
        consigns:[] as ConsignSheet[],
        isLoading:true,
		editIndex:-1,
		deleteIndex:-1,
        pager:null,
        cond:Inc.defaultConsignSheetSearchCondition(),
    });
    const search = (cond:ConsignSheetSearchCondition,first?:boolean)=>{
        //console.log("search",cond);
        setStates({...states,deleteIndex:-1,"isLoading":true});
        window.scrollTo(0,0);
        if( first ){
            page = 1;
        }
        Ajax.search("consign/list",cond,page,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({consigns:res.consigns,editIndex:-1,deleteIndex:-1,cond:cond,pager:res.pager,isLoading:false});
            } else {
                setStates({...states,consigns:[],deleteIndex:-1,pager:null,"isLoading":false});
            }
        });
    }
	const openInput = (index:number)=>{
		setStates({...states,editIndex:index});
	}
	const closeInput = ()=>{
		setStates({...states,editIndex:-1});
	}
	const openDelete = (index:number)=>{
		setStates({...states,deleteIndex:index});
	}
	const closeDelete = ()=>{
		setStates({...states,deleteIndex:-1});
	}
	const jump = (p:number)=>{
		//send(values,p);
		page = p;
		search(states.cond);
	}
	const ConsignRow = (props:{consign:any,owner_id:number,index:number})=>{
		const [rowstate,setRowstate] = useState({open:false,items:[]});
		const toggle = async ()=>{			
			if( rowstate.items.length===0 ){
				const res = await Ajax.sendAwait("consign/items",{consign_sheet_id:props.consign.consign_sheet_id});
				//console.log(res);
				setRowstate({...rowstate,items:res.items,open:!rowstate.open});
				//setRowstate({...rowstate,open:!rowstate.open});
			} else {
				setRowstate({...rowstate,open:!rowstate.open});
			}
		}
		return (
			<>
			<TableRow>
				<TableCell className={classes.tableCellNowrap} style={{width:'4em'}} align='center'>
					{props.consign.consign_sheet_id}
				</TableCell>
				<TableCell className={classes.tableCellNowrap} sx={{width:{md:'auto',lg:'6.5em'}}} align='center'>
					{props.consign.created}
				</TableCell>
				<TableCell className={classes.tableCellNowrap} sx={{display:{xs:'none',sm:'table-cell'},width:{md:'auto',lg:'6.5em'}}} align='center'>
					{props.consign.arrived}
				</TableCell>
				<TableCell className={classes.tableCellNowrap} sx={{width:{md:'auto',lg:'6.5em'}}} align='center'>
					{props.consign.completed}
				</TableCell>
				{(props.consign.courier || props.consign.tracking) ? (
				<TableCell className={classes.tableCellNowrap} align='center' sx={{display:{xs:'none',sm:'table-cell'}}}>
					<CopyToClipboard text={props.consign.tracking ? props.consign.tracking : '登録なし'} onCopy={copyTracking}><Tooltip title="追跡番号をコピーする"><Button variant="text" size="small">{props.consign.courier} {props.consign.tracking}</Button></Tooltip></CopyToClipboard>
				</TableCell>
				):(
				<TableCell className={classes.tableCellNowrap} align='center' style={{color:'gray'}} sx={{display:{xs:'none',sm:'table-cell'}}}>
					未設定
				</TableCell>
				)}
				<TableCell className={classes.tableCellNowrap} style={{width:'4em'}} align='center'>
					{Tools.colorLabel("consign_status",props.consign.status,props.consign.status_label)}<br/>
				</TableCell>
				<TableCell className={classes.tableCellNowrap} align="right" sx={{width:{xs:'1.5em',sm:'2em'}}}><IconButton sx={{margin:'0',padding:'0',marginRight:{xs:'0',sm:'0.5em'}}} onClick={toggle}><ArrowDropDownIcon/></IconButton></TableCell>
			</TableRow>
			{rowstate.open &&
			<TableRow>
				<TableCell style={{ paddingBottom: '3em', paddingTop: 0, paddingLeft: '1em', paddingRight: 0}} colSpan={9}>
					{rowstate.items ? (
					<Table>
						<TableBody>
						{rowstate.items.map((item:any,index:number)=>{
							const key = "item"+index;
							return (
						<TableRow key={key}>
							<TableCell className={classes.tableCellDense} align="center" style={{width:'3em',verticalAlign:'middle'}}><StoreImg owner_id={props.owner_id} img_id={item.img_id} className="imgList"/></TableCell>
							<TableCell style={{width:'4em'}} sx={{display:{xs:'none',sm:'table-cell'}}}><span className={classes.itemId}>ID:{item.item_id}</span></TableCell>
							<TableCell>
								<Box sx={{display:{xs:'table-cell',sm:'none'}}}><span className={classes.itemId}>ID:{item.item_id}</span></Box>
								{item.item_name}
							</TableCell>
							<TableCell style={{width:'6em'}} align='right'>{item.su}{item.unit}</TableCell>
						</TableRow>
							)
						})}
						</TableBody>
					</Table>
					):(
					<Box style={{textAlign:'center',padding:'2em 0'}}>
						<CircularProgress />
					</Box>
					)}
					<Table>
						<TableBody>
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
									追跡番号
								</TableCell>
								{(props.consign.courier || props.consign.tracking) ? (
								<TableCell>
									<CopyToClipboard text={props.consign.tracking ? props.consign.tracking : '登録なし'} onCopy={copyTracking}><Tooltip title="追跡番号をコピーする"><Button variant="text" size="small">{props.consign.courier} {props.consign.tracking}</Button></Tooltip></CopyToClipboard>
								</TableCell>
								):(
								<TableCell>
									未設定
								</TableCell>
								)}
							</TableRow>
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
									到着日
								</TableCell>
								<TableCell>
									{props.consign.arrived}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
									完了日
								</TableCell>
								<TableCell>
									{props.consign.completed}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
									備考
								</TableCell>
								<TableCell>
									<MultiLines text={props.consign.memo} empty={true}/>
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
					<Box sx={{ marginTop:'0.5em', display: 'flex',justifyContent: 'space-between' }}>
						<Button variant="text" size="small" color="error" disabled={props.consign.status!=='0'} onClick={()=>openDelete(props.index)}><DeleteForeverIcon/>削除</Button>
						<Box>
							<Button variant="outlined" size="small" color="primary" onClick={()=>downloadPDF(props.consign.consign_sheet_id)} style={{marginRight:'0.25em'}}><FileDownloadIcon/>PDF</Button>
							<Button variant="outlined" size="small" color="primary" onClick={()=>openInput(props.index)}><NoteAltIcon/>追跡番号の連絡</Button>
						</Box>
					</Box>
				</TableCell>
			</TableRow>
			}
			</>
		);
	}
	const consignRows = useMemo(()=>{
		return states.consigns.map((consign:any,index:number)=>{
			const key = "consign"+index;
			return <ConsignRow consign={consign} owner_id={pr.owner.owner_id} index={index} key={key}/>
		})
	},[states.consigns])

	const updateConsign = async (consign:ConsignSheet)=>{
		setStates({...states,isLoading:true});
		if( consign.other!=='' ){
			consign.courier = consign.other;
		}
		const res = await Ajax.sendAwait("consign/update",{consign_sheet_id:consign.consign_sheet_id,courier:consign.courier,tracking:consign.tracking,memo:consign.memo});
		if( res.ok ){
			const consigns = [...states.consigns];
			if(consigns[states.editIndex]){
				consigns[states.editIndex].tracking = consign.tracking;
				consigns[states.editIndex].courier = consign.courier;
				consigns[states.editIndex].other = consign.other;
				consigns[states.editIndex].memo = consign.memo;
			}
			setStates({...states,consigns:consigns,editIndex:-1,isLoading:false});
		} else {
			setStates({...states,editIndex:-1,isLoading:false});
		}
	}

	const deleteConsign = async ()=>{
		const id = states.consigns[states.deleteIndex].consign_sheet_id;
		setStates({...states,isLoading:true});
		const res = await Ajax.sendAwait("consign/delete",{consign_sheet_id:id});
		if( res.ok ){
			//setStates({...states,deleteIndex:-1,isLoading:false});
			search(states.cond);
		} else {
			setStates({...states,editIndex:-1,isLoading:false});
		}
	}

    const downloadPDF = (sheetId:number)=>{
        Ajax.download("letter/download",{filename:'納品書'+sheetId,sheet_id:sheetId},(res:any)=>{
            if( res.ok ){
                //console.log("ok");
            }
        });
    }	

	const closeToast = ()=>{
		setToast('');
	}

	const copyTracking = ()=>{
		setToast('追跡番号をクリップボードにコピーしました');
	}

	if( pr.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}
	
	return (
		<div id="consign_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="納品の履歴" icon="cart"/>
                        <div style={{marginBottom:"2em"}}>
	                        作成した納品書の一覧です。納品手続の進捗確認にご利用ください。<br/>
    	                    各納品の一番右の▼をタップして詳細情報を表示すると、納品書PDFの再発行や荷物の追跡番号（問い合わせ番号）のご連絡ができます。<br/>
							<Box sx={{display:{md:'block',lg:'none'}}}>
								<FormControl fullWidth={true} style={{margin:"1em 0"}}>
									<Button variant="contained" color="primary" style={{width:"100%"}} component={Link} to="/letter"><AddIcon/>新しい納品書を作成</Button>
								</FormControl>
							</Box>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{xs:'none',lg:'table-cell'}}}>納品受付番号</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{xs:'table-cell',lg:'none'}}}>番号</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center">作成日</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{xs:'none',sm:'table-cell'}}}>到着日</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center">完了日</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{xs:'none',sm:'table-cell'}}}>追跡番号</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center">状態</TableCell>
									<TableCell className={classes.tableHeadNowrap}>　</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>{consignRows}</TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					<Paper className={classes.paper} sx={{display:{md:'none',lg:'block'},marginBottom:"1em"}}>
						<Title text="納品する" size={2}/>
						<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
							<Button variant="contained" color="primary" style={{width:"100%"}} component={Link} to="/letter"><AddIcon/>新しい納品書を作成</Button>
						</FormControl>
                        <ul className={classes.guideUl}>
                            <li className={classes.guideLi}>納品書はPDFで出力されますので、プリンタやコンビニのコピー機などで印刷してご利用いただけます</li>
							<li className={classes.guideLi}>手書きの納品書をご利用の場合も、納品書作成の手続きを行って「納品受付番号」を取得してください</li>
                        </ul>
					</Paper>
                    <Paper className={classes.paper}>
                        <ConsignListSearch update={search} bank={pr.bank} bankKey={"savedConsignListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>
			<ConsignInput consigns={states.consigns} index={states.editIndex} isOpen={states.editIndex>=0} yes={updateConsign} no={closeInput}/>
			<Yesno mes="この納品書を削除してよろしいですか？" isOpen={states.deleteIndex>=0} yes={deleteConsign} no={closeDelete}/>
            <Loading isLoading={states.isLoading}/>
			<Toast mes={toast} close={closeToast}/>
		</div>
	);
}

export default ConsignList;
